
import { DeviceAppsCategoriesTable } from "./DeviceAppsCategoriesTable";

interface DeviceAppsCategoriesContentProps {
  deviceId: string;
}

export const DeviceAppsCategoriesContent = ({ deviceId }: DeviceAppsCategoriesContentProps) => {
  return <DeviceAppsCategoriesTable deviceId={deviceId} />;
};
